<template>
    <div><!-- COA 上傳 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-end mb-2">
                    <button class="btn btn-sm btn-success" v-if="canSave" @click="savedDataEvent">{{$t('Buttons.SavedData')}}</button>
                    <button class="btn btn-sm btn-dark ml-2" @click="$router.go(-1)">{{$t('Buttons.GoBack')}}</button>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="title po-no requiredCss">PO_NO</div>
                        <div class="content">
                            <!-- <Select2 style="width: 500px;" v-if="isAddnew" 
                                        v-model="coaUploadRow.po" 
                                        :options="poNoListFilter()" 
                                        :settings="{ multiple: false, dropdownAutoWidth : true , width: '100%' }"/> -->
                            <div>
                                <input class="input" :disabled="true" type="text" v-model="coaUploadRow.po" />
                            </div>
                            <button class="btn btn-sm btn-primary ml-2" data-toggle="modal" data-target="#searchPoNoModal" @click="openPoNoModal" v-if="isAddnew">
                                <i class="el-icon-search"></i>
                            </button>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title  requiredCss">{{ i18n("COA.PartNumber") }}</div>
                        <div class="content">
                            <Select2 v-if="isAddnew" style="width: 240px;" 
                                    :options="partnumberListFilter" 
                                    :settings="{ multiple: false, dropdownAutoWidth : true , width: '100%'}"
                                    @select="partnumberSelectEvent($event)"/>                            
                            <input class="input" v-else readonly type="text" v-model="coaUploadRow.partnumber">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title requiredCss">{{ i18n("COA.Parts") }}</div>
                        <div class="content">
                            <input class="input" type="text" readonly  v-model="coaUploadRow.partname">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="title total ">{{ i18n("COA.TotalQuantity") }}&emsp;</div>
                        <div class="content">{{coaUploadRow.coaTotcnt}}</div>
                    </div>

                    <div class="col-md-12">
                        <div class="title add">
                            <button class="btn btn-danger" v-if="isAddnew" @click="addRowEvent">+</button>
                        </div>
                        <div class="content">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th class="text-center requiredCss">{{ i18n("COA.Batch") }}</th>
                                        <th class="text-center requiredCss">{{ i18n("COA.Quantity") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item , index) in coaDtlRows" :key="index">
                                        <td class="text-center">
                                            <input type="text" :disabled="!isAddnew"  maxlength="50" v-model="item.coaDtlNum">
                                        </td>
                                        <td class="text-center">
                                            <input type="text" :disabled="!isAddnew" v-integer maxlength="8" v-model="item.coaCnt">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="title coa-upload requiredCss">{{ i18n("COA.COAUpload") }}</div>
                        <div class="content file-content">
                            <div class="file-container">
                                <input type="file" v-if="canEdit" style="width:300px;" @change="onFileSelection1"> 
                                <span>{{ i18n("COA.Uploaded") }}: </span>
                                <a class="fileLink" v-if="showFileLink(1)" target="_blank" :href="getFileLink(1)">{{getFileName(1)}}</a>
                            </div>
                            <div class="file-container">
                                <input type="file" v-if="canEdit" style="width:300px;" @change="onFileSelection2"> 
                                <span>{{ i18n("COA.Uploaded") }}: </span>
                                <a class="fileLink" v-if="showFileLink(2)" target="_blank" :href="getFileLink(2)">{{getFileName(2)}}</a>
                            </div>
                            <div class="file-container">
                                <input type="file" v-if="canEdit" style="width:300px;" @change="onFileSelection3"> 
                                <span>{{ i18n("COA.Uploaded") }}: </span>
                                <a class="fileLink" v-if="showFileLink(3)" target="_blank" :href="getFileLink(3)">{{getFileName(3)}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title requiredCss">{{ i18n("COA.AuditDescription") }}</div>
                        <div class="content"  v-if="showConfirmUI">
                            <textarea maxlength="50" cols="10" rows="5" v-model="coaUploadRow.coaMemo"></textarea>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="title">{{ i18n("COA.Audit") }}</div>
                        <div class="content radio_container"  v-if="showConfirmUI">
                            <span v-for="(item, key) in rowStatusList" :key="'coaRowStatus_input_' + key">
                                <input type="radio" :name="'coa_RowStatusOpt'" v-model="coaUploadRow.coaStatus" :value="item.rowStatusId" >{{item.rowStatusCaption}}
                            </span>
                        </div>
                        <div class="content radio_container"  v-else>{{coaUploadRow.coaStatusTxt}}</div>
                    </div>

                    <div class="col-md-12">
                        <table class="table table-bordered log">
                            <thead class="thead-light">
                                <tr>
                                    <th class="text-center">{{ i18n("COA.LOGTime") }}</th>
                                    <th class="text-center">{{ i18n("COA.AuditDescription") }}</th>
                                    <th class="text-center">{{ i18n("COA.Status") }}</th>
                                    <th class="text-center">{{ i18n("COA.AssigneeOfUpdate") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item , index) in coaLogRows" :key="index">
                                    <td class="text-center">{{fixDateTime(item.logDate)}}</td>
                                    <td class="text-center">{{item.logMemo}}</td>
                                    <td class="text-center">{{getCoaStatusTxt(item.logStatus)}}</td>
                                    <td class="text-center">{{item.logCreateusername}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </CCardBody>
        </CCard>

        <!-- search PO_NO Modal -->
        <div class="modal fade" :id="'searchPoNoModal'" tabindex="-1" role="dialog" aria-labelledby="addModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard ="false">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{$t('Buttons.Query')}} PO_NO
                    </div>
                    <div class="modal-body">
                        <div class="filter-block">
                            <div class="filter-field">
                                <input name="name" v-model="PoNo" placeholder="PO_NO 關鍵字" />
                            </div>
                            <button class="btn btn-sm btn-primary ml-2" @click="searchPoNo">{{$t('Buttons.Query')}}</button>
                        </div>
                        <el-table
                            :data="poNoList"
                            style="width: 100%"
                            :header-cell-style="{ background: '#ccd9e2', color: '#343b55', color: '#343b55',textAlign: 'center' }"
                            border>
                            <template slot="empty">
                                <div>暫無資料</div>
                            </template>
                            <el-table-column
                                align="center"
                                label="PO_NO">
                                <template slot-scope="scope">
                                    <a @click="choosePoNo(scope.row.id)" style="display: block;cursor: pointer;">{{ scope.row.id}}</a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {            
            rowStatusList: this.$t('coaStatusList'), //狀態 清單
            isReject : false,
            isAddnew : false,
            showConfirmUI : false,
            isDisablePoNo: false,            
            coaUploadRow: {
                coaDtlList: [],
                coaLogList: []
            },
            coaDtlRows : [],
            coaLogRows : [],
            defaultItem : {id:'' , text :'                     '},
            poNoList :[{id:'' , text :'                     '}],
            partnumberListFilter : [{id:'' , text :'                     '}] ,
            partnumberList : [],

            PoNo: '',
        }
    },
    props : {
    },    
    methods: {
        poNoListFilter (){
            const list = this.poNoList;
            if(list.length === 0){
                list.push(this.defaultItem);
            }
            return list;
        },
        getDetail(guid) {//目前編輯的單筆 COA 上傳 +明細內容清單        
            if('new' === guid){                
                this.isAddnew = true;                  
            }else{                
                this.isAddnew = false;                
            }
            const url = `${this.$apiUrl_Quality}/GetCOAUploadDetail/${guid}`
            this.updateLoading(true)
            this.axios.get(url).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功
                    const resultRow = response.data                    
                    if(!this.isAddnew){                        
                        if(!this.isMember){
                            this.showConfirmUI = true;
                        }                        
                    }                    
                    if(resultRow.coaStatus === 2){
                        this.isReject = true;
                    }else{
                        if(resultRow.coaStatus === 1){
                            this.showConfirmUI = false; //完成
                        }
                        this.isReject = false;   
                    }
                    if(resultRow.coaDtlList){
                        this.coaDtlRows = resultRow.coaDtlList;
                    }else{
                        this.coaDtlRows = [];
                        if(this.isAddnew || this.isReject){
                            this.coaDtlRows.push({coaDtlNum : '', coaDtlCnt: 0});
                        }
                    }
                    if(resultRow.coaLogList){
                        this.coaLogRows = resultRow.coaLogList;
                        resultRow.coaLogList = null;
                    }
                    resultRow.coaStatusTxt = this.coaStatusMap[resultRow.coaStatus];
                    this.coaUploadRow = resultRow;
                    this.coaUploadRow.oldCoaStatus = this.coaUploadRow.coaStatus;
                    this.coaUploadRow.hadCoaFile1 = this.coaUploadRow.coaFile1;
                    this.coaUploadRow.hadCoaFile2 = this.coaUploadRow.coaFile2;
                    this.coaUploadRow.hadCoaFile3 = this.coaUploadRow.coaFile3;                   
                    if(this.canSave){
                        this.coaUploadRow.coaMemo = '';
                    }
                    this.updateLoading(false)
                }
            })
        },
        checkSaveData (){ //檢核必要儲存資料
            const chkRow= this.coaUploadRow;            
            if(this.isMember || this.isAddnew){
                chkRow.coaMemo = ' ';
            }
            if(!chkRow.po){
                this.$alert('PO_NO 為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            if(!chkRow.partnumber){
                this.$alert('部材料號為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            if(!chkRow.partname){
                this.$alert('部材名稱為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }            
            if(!chkRow.coaMemo){                
                this.$alert('審核說明為必要輸入資料！','警告',{type: 'warning'});
                return false;
            }
            if(!this.isMember && chkRow.coaStatus === 0){
                this.$alert('審核狀態不得為待審核！','警告',{type: 'warning'});
                return false;
            }
            const chkDtlRows= this.coaDtlRows;
            let okRowCount = 0;
            let hadError = false;
            chkDtlRows.forEach(r=> {
                if(r.coaDtlNum && r.coaCnt >0){
                    okRowCount += 1;
                }else{
                    if(r.coaDtlNum && !r.coaCnt ){
                        hadError = true;
                    }else if(!r.coaDtlNum && r.coaCnt >0){
                        hadError = true;
                    }
                }
            });
            if(hadError){
                this.$alert('批次/數量資料必須同時都輸入！','警告',{type: 'warning'});
                return false;
            }
            if(okRowCount === 0){
                this.$alert('批次/數量至少要有一筆資料！','警告',{type: 'warning'});
                return false;
            }
            if(this.canEdit){
                if(!this.coaUploadRow.file1Base64 && !this.coaUploadRow.file2Base64 && !this.coaUploadRow.file3Base64){
                    let msg;
                    if(this.isAddnew){
                        msg = '須至少一筆檔案上傳！';
                    }else{
                        msg = '請更新檔案後再上傳！';
                    }
                    this.$alert(msg,'警告',{type: 'warning'});
                    return false;
                }
            }
            return true;
        },
        savedDataEvent (){
            if(!this.checkSaveData()) return;
            if(this.isAddnew || this.isReject){
                this.coaUploadRow.coaStatus = 0;
            }
            this.coaUploadRow.coaDtlList = this.coaDtlRows;
            const url = `${this.$apiUrl_Quality}/UpdateCoaUploadRow`;
            const param = this.coaUploadRow;
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功                    
                    this.goBack();
                }                    
            }); 
        },
        addRowEvent (){
            if(this.isAddnew || this.isReject){
                this.coaDtlRows.push({coaDtlNum : '', coaDtlCnt: 0});
            }
        },
        getCoaStatusTxt(status){
            const map =this.coaStatusMap;
            let v = map[status];
            if(v){
                return v;
            }
            return '';
        },
        partnumberSelectEvent({id,txz01}){
            this.coaUploadRow.partnumber =id;
            this.coaUploadRow.partname = txz01 ;            
        },
        onFileSelection1(e) { 
            this.onFileSelection(e , 1);
        },
        onFileSelection2(e) { 
            this.onFileSelection(e , 2);
        },
        onFileSelection3(e) { 
            this.onFileSelection(e , 3);
        },
        onFileSelection (e ,num) { //--檔案挑選後，判斷並處理此檔案物件
            const maxFileByte = 5242880;            
            const acceptedImageTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf'];
            // add all selected files
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return false;
            const self = this;
            let file = files[0];
            let fileType = file['type'];
            let isAccpetType = acceptedImageTypes.includes(fileType);
            if (!isAccpetType) {
                e.target.value = '';
                this.$alert('檔案格式需為 Excel (Excel 2007 以上版本)/ PDF，請重新上傳!','警告',{type: 'warning'});
            } else if (maxFileByte < file.size) {
                e.target.value = '';
                this.$alert('檔案大小需5Mb以下，請重新上傳!','警告',{type: 'warning'});
            } else {                
                const reader = new FileReader();
                reader.readAsDataURL(file);                                 
                reader.onload = function(event) {
                    const itemBase64result = reader.result.substr(event.target.result.indexOf(',') + 1);
                    if(itemBase64result) {
                        if(num === 1){
                            self.coaUploadRow.coaFile1 = file.name;
                            self.coaUploadRow.file1Base64 = itemBase64result;
                        }else if(num === 2){
                            self.coaUploadRow.coaFile2 = file.name;
                            self.coaUploadRow.file2Base64 = itemBase64result;
                        }else if(num === 3){
                            self.coaUploadRow.coaFile3 = file.name;
                            self.coaUploadRow.file3Base64 = itemBase64result;
                        }
                    }
                };
            }
        },
        showFileLink (num){
            if(num === 1 && this.coaUploadRow.hadCoaFile1){
                return true;
            }else if(num === 2 && this.coaUploadRow.hadCoaFile1){
                return true;
            }else if(num === 3 && this.coaUploadRow.hadCoaFile1){
                return true;
            }
            return false;
        },
        getFileLink (num){
            const baseUrl = this.$apiUrl_Quality;
            const coaGuid= this.coaUploadRow.coaGuid;
            if(num === 1 && this.coaUploadRow.hadCoaFile1){
                return `${baseUrl}/CoaDownload/1/${coaGuid}`;
            }else if(num === 2 && this.coaUploadRow.hadCoaFile2){
                return `${baseUrl}/CoaDownload/2/${coaGuid}`;
            }else if(num === 3 && this.coaUploadRow.hadCoaFile3){
                return `${baseUrl}/CoaDownload/3/${coaGuid}`;
            }
        },
        getFileName (num){
            if(num === 1 && this.coaUploadRow.hadCoaFile1){
                return this.fixFileName(this.coaUploadRow.hadCoaFile1);
            }else if(num === 2 && this.coaUploadRow.hadCoaFile2){
                return this.fixFileName(this.coaUploadRow.hadCoaFile2);
            }else if(num === 3 && this.coaUploadRow.hadCoaFile3){
                return this.fixFileName(this.coaUploadRow.hadCoaFile3);
            }
            return '';
        },

        // 打開 PONO Modal
        openPoNoModal (){
            this.PoNo = "";
            this.searchPoNo();
        },

        // 搜尋 PONO Api
        searchPoNo (){
            const url = `${this.$baseApiUrl}/Quality/GetPoNoList`;
            this.updateLoading(true);
            const params = {
                PoNo: this.PoNo,
                Unrestricted: true,
            };

            this.axios.get(url, { params }).then((response) => {
                // console.log('PoNo列表', response.data);
                
                const { status, statusMessage } = response.data;
                this.updateLoading(false);
                if (status) {
                    this.$alert(statusMessage, "警告", { type: "warning" });
                } else {
                    //--成功
                    const poNoRows = []
                    const partnumberRows = []
                    if(response.data && response.data.length >0){
                        const mapChk = {};                
                        response.data.forEach(r => {
                            if(!mapChk[r.ebeln]){
                                poNoRows.push({id : r.ebeln , text: r.ebeln});
                                mapChk[r.ebeln] = 'Y';
                            }
                            partnumberRows.push({poNo : r.ebeln , matnr: r.matnr, txz01: r.txz01});
                        });
                    }
                    this.poNoList = poNoRows;
                    this.poNoOriginalList = poNoRows;
                    this.partnumberList = partnumberRows;
                }
            });
        },

        // 選擇 PONO
        choosePoNo(id) {
            this.coaUploadRow.po = id
            $("#searchPoNoModal").modal("hide");
        },

        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"]),
        coaStatusMap (){
            return this.listToMap(this.$t('coaStatusList'), 'rowStatusId' ,'rowStatusCaption');
        },
        canEdit (){
            if(this.coaUploadRow.oldCoaStatus && this.coaUploadRow.oldCoaStatus === 1){
                return false;//已完成案件都不需處理
            }
            return (this.isAddnew || this.isReject) && this.isMember;
        },
        canSave (){
            if(this.coaUploadRow.oldCoaStatus && this.coaUploadRow.oldCoaStatus === 1){
                return false;//已完成案件都不需處理
            }
            if(this.isMember){
                return (this.isAddnew || this.isReject);
            }else{
                return true;
            }
        }
    },
	mounted() {
        const coaGuid = sessionStorage.getItem('coaGuid');
        if(coaGuid){
            this.getDetail(coaGuid);
        }else{
            this.goBack();
        }

        //--訂單編號 + 部材相關資料
        this.searchPoNo();

        // this.$store.dispatch('getPoNoList',{}).then((data) => {
        //     const poNoRows= []
        //     const partnumberRows= []
        //     if(data && data.length >0){
        //         const mapChk = {};                
        //         data.forEach(r => {
        //             if(!mapChk[r.ebeln]){
        //                 poNoRows.push({id : r.ebeln , text: r.ebeln});
        //                 mapChk[r.ebeln] = 'Y';
        //             }
        //             partnumberRows.push({poNo : r.ebeln , matnr: r.matnr, txz01: r.txz01});
        //         });
        //     }
        //     this.poNoList = poNoRows;
        //     this.partnumberList = partnumberRows;
        // }); 
	},
    watch: {
         "lang": function() {
            this.rowStatusList = this.$t('coaStatusList') //狀態 清單
        },
        'coaUploadRow.po': function(v) {
            if(v && this.isAddnew){
                const poNo = v;
                this.coaUploadRow.partnumber = '';
                this.coaUploadRow.partname = '';
                const partnumberList = this.partnumberList;
                const list = this.partnumberListFilter;            
                if(poNo && partnumberList){                    
                    list.splice(0);
                    partnumberList.forEach(r => {
                        if(r.poNo === poNo && r.matnr){                        
                            list.push({id : r.matnr , text: r.matnr ,txz01:r.txz01 });
                        }                    
                    });
                }                
                if(list.length === 0){
                    list.push(this.defaultItem);
                }                
            }            
        }
    },
    created() {        
    }
}
</script>

<style lang="scss" scoped>
.btn-edit {
    background-color: #343b55;
    color: white;
}

.row {
    padding: 0 12px;
}

.col-md-6 {
    display: flex;
    padding: 0;

    .title.batch {
        border-bottom: none;
        padding: 0 3.4rem;
    }

    .title {
        background-color: #BDD6EE;
        width: 144px;
        justify-content: center;
    }

    .radio_container {
        flex-direction: column;
        justify-content: center;
        // text-align: left;

        span {
            width: 100%;
        }
    }

    .content {
        flex: 1;

        input[type="radio"] {
            margin: 0 .5rem;
        }

        textarea {
            width: 100%;
            margin: 0 .5rem;
            border-radius: 6px;
        }

        .input {
            width: 100%;
            height: 35px;
            border-radius: 6px;
        }

    }

    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .2rem 1.2rem;
    }
}

.col-md-12 {
    display: flex;
    padding: 0;

    .title {
        background-color: #BDD6EE;
        width: 144px;
    }
    .title, .content {
        display: flex;
        align-items: center;

        border: solid 1px;
        padding: .6rem 1rem;
    }
    .po-no {
        padding: 0 2.7rem;
    }
    .add {
        padding: 0 2.6rem;
        align-items: start;
        padding-top: 1rem;
        border-top: none;
    }
    .total {
        padding: 0 2.4rem;
    }
    .coa-upload {
        padding: 0 2.3rem;
    }
    .content {
        flex: 1;
        textarea {
            width: 100%;
            margin: 0 .5rem;
        }
        select {
            width: 100%;
            margin: 0 1.2rem;

            height: 35px;
            border-radius: 6px;
        }
        input {
            width: 100%;
        }
    }
    .file-content {
        display: flex;
        flex-direction: column;

        .file-container {
            // flex: 1;
            display: flex;
            align-items: center;

            width: 100%;
            margin: .5rem 0;

            input[type="file"] {
                height: 100%;
                border: solid 1px black;
                border-radius: 5px;
                margin: 0 .5rem;
                padding: .5rem .2rem;
            }
        }
    }
}
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}
.table, .table-bordered th, .table-bordered td {
    border-color: black;
}
.table.log th {
    // background-color: #FFC300;
    background-color: #FFD966;
    color: #000;
}
.table tr:nth-child(even) {
    background-color: transparent;
}
.requiredCss::before{
    content: "*";
    color: #f26161;
    font-weight: bolder;
    margin-bottom: 2px;
}

.btn-secondary {
  color: #fff;
  background-color: gray;
}

.btn-blue {
  color: #fff !important;
  background: #343b55;
}

.modal-body {
  background-color: #eceef6;
}
</style>
